document.addEventListener('DOMContentLoaded', function () {

  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const jsonLd = productInfo.querySelector('script[type="application/ld+json"]');
  if (!jsonLd) return;

  let productData;
  try { productData = JSON.parse(jsonLd.textContent); } catch(e) { return; }

  const variants = productData?.hasVariant;
  if (!variants || variants.length <= 1) return;

  const submitBtn = productInfo.querySelector('product-form [name="add"]');
  if (!submitBtn) return;

  let variantChosen = false;

  const style = document.createElement('style');
  style.textContent = `
   #variant-guard-toast {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%) scale(0.95);
      background: #323841;
      color: #fff;
      padding: 1.4rem 2.8rem; /* Ajustado para dar espaço às curvas ovais */
      border-radius: 9999px; /* Torna as extremidades 100% ovais */
      display: flex;
      align-items: center;
      gap: 1rem;
      box-shadow: 0 8px 36px rgba(0,0,0,0.35);
      z-index: 99999;
      opacity: 0;
      transition: opacity 0.35s ease, transform 0.35s ease;
      pointer-events: none;
      max-width: 90vw;
      line-height: 1.5;
    }

   #variant-guard-toast.visible {
      opacity: 1;
      transform: translateX(-50%) translateY(-50%) scale(1);
    }

    #variant-guard-toast .toast-icon {
      font-size: 2.2rem;
      flex-shrink: 0;
    }

    #variant-guard-toast .toast-text {
      font-size: 1.35rem;
      font-weight: 500;
      letter-spacing: 0.01em;
    }

    @media screen and (max-width: 749px) {
      #variant-guard-toast {
        white-space: nowrap;
        width: max-content;
        max-width: 95vw;
        padding: 1rem 2rem; /* Mais espaço nas laterais para o texto não bater na curva */
        border-radius: 9999px; /* Mantém o formato oval no mobile */
        gap: 0.8rem;
      }

      #variant-guard-toast .toast-icon {
        font-size: 1.6rem;
      }

      #variant-guard-toast .toast-text {
        font-size: 3.2vw; 
      }
    }

    @media screen and (max-width: 350px) {
      #variant-guard-toast .toast-text {
        font-size: 11px; 
      }
    }
  `;
  document.head.appendChild(style);

  const toast = document.createElement('div');
  toast.id = 'variant-guard-toast';
  // Frase ligeiramente encurtada para viabilizar o design em linha no mobile
  toast.innerHTML = `
    <span class="toast-icon">⚠️</span>
    <span class="toast-text">Seleciona uma opção antes de adicionar ao carrinho.</span>
  `;
  document.body.appendChild(toast);

  let toastTimeout;

  const showToast = () => {
    clearTimeout(toastTimeout);
    toast.classList.add('visible');
    toastTimeout = setTimeout(() => {
      toast.classList.remove('visible');
    }, 2100);
  };

  const blockIfNoVariant = (e) => {
    if (!variantChosen) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showToast();
      const picker = productInfo.querySelector(
        'variant-selects, variant-radios, .product-form__input'
      );
      if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  // Botão "Adicionar ao carrinho"
  ['click', 'touchend'].forEach(eventType => {
    submitBtn.addEventListener(eventType, blockIfNoVariant);
  });

  // Botão "Comprar com Shop" e outros botões de pagamento dinâmico
  const interceptShopPay = () => {
    const shopPayBtn = productInfo.querySelector(
      'shop-pay-wallet-button, .shopify-payment-button__button, shopify-accelerated-checkout'
    );
    if (!shopPayBtn) return;

    ['click', 'touchend'].forEach(eventType => {
      shopPayBtn.addEventListener(eventType, blockIfNoVariant, true);
    });

    if (shopPayBtn.shadowRoot) {
      const innerBtn = shopPayBtn.shadowRoot.querySelector('button');
      if (innerBtn) {
        ['click', 'touchend'].forEach(eventType => {
          innerBtn.addEventListener(eventType, blockIfNoVariant, true);
        });
      }
    }
  };

  interceptShopPay();
  setTimeout(interceptShopPay, 1000);
  setTimeout(interceptShopPay, 2500);

  const markChosen = () => {
    variantChosen = true;
    toast.classList.remove('visible');
    clearTimeout(toastTimeout);
  };

  productInfo.querySelectorAll('variant-selects select').forEach(el => {
    el.addEventListener('change', markChosen);
  });

  productInfo.querySelectorAll('variant-radios input[type="radio"]').forEach(el => {
    el.addEventListener('change', markChosen);
  });

  productInfo.querySelectorAll('.swatch-input__input').forEach(el => {
    el.addEventListener('change', markChosen);
  });

});